import React from "react";
import { motion } from "framer-motion";
import { LayoutGridIcon, FootprintsIcon, FolderOpenIcon, SlidersHorizontalIcon, PencilLineIcon, InfinityIcon, CheckIcon, BoxIcon } from "lucide-react";
interface DifferenceCard {
  icon: BoxIcon;
  title: string;
  description: string;
}
const cards: DifferenceCard[] = [{
  icon: LayoutGridIcon,
  title: 'Visual y fácil de recorrer',
  description: 'El contenido está presentado de manera clara para que puedas encontrar rápidamente la información que necesitás.'
}, {
  icon: FootprintsIcon,
  title: 'Creado para comenzar de a poco',
  description: 'No tenés que utilizar todos los materiales ni realizar rutinas extensas. Podés empezar por una sola práctica.'
}, {
  icon: FolderOpenIcon,
  title: 'Todo organizado',
  description: 'La guía y los ocho bonos se encuentran separados y ordenados para que sepas qué recurso consultar en cada momento.'
}, {
  icon: SlidersHorizontalIcon,
  title: 'Prácticas posibles de adaptar',
  description: 'Elegí las herramientas que conecten con vos y ajustalas a tu tiempo, experiencia y momento personal.'
}, {
  icon: PencilLineIcon,
  title: 'Una experiencia que podés registrar',
  description: 'Utilizá el planificador y el diario para observar qué prácticas realizás y cómo cambia tu experiencia.'
}, {
  icon: InfinityIcon,
  title: 'Disponible cada vez que lo necesites',
  description: 'El acceso es de por vida para que puedas volver al material cuando aparezca una nueva necesidad.'
}];
const trustItems = ['Pago único.', 'Sin suscripción.', 'Acceso digital inmediato.', 'Acceso de por vida.', 'Disponible para toda Latinoamérica.', 'Conversión a moneda local antes de confirmar la compra.'];
export function Testimonials() {
  return <section className="w-full bg-cream px-5 py-12 sm:py-20" data-id="element-250" data-mp="v4emsqowa5vs">
      <div className="mx-auto max-w-5xl" data-id="element-251" data-mp="1ius7fw55h2gc">
        <div className="mx-auto max-w-2xl text-center" data-id="element-252" data-mp="1itqx5tvykjzo">
          <span className="mb-5 inline-block rounded-full border border-gold/50 bg-card px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-plum" data-id="element-253" data-mp="1nmk14fjlroap">
            Una experiencia creada para que realmente puedas comenzar
          </span>
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-plum sm:text-4xl" data-id="element-254" data-mp="1sjpd2yf75jfw">
            No es otro conjunto de archivos que vas a descargar y olvidar
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-plum/75 sm:text-base" data-id="element-255" data-mp="1jhpui1oja7au">
            Aura Viva 2026 organiza cada recurso para que puedas encontrar una herramienta concreta
            sin sentir que primero tenés que leerlo todo.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-256" data-mp="14sjzyr0n559a">
          {cards.map((card, i) => {
          const Icon = card.icon;
          return <motion.article key={card.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.2
          }} transition={{
            duration: 0.3,
            delay: i % 3 * 0.06,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex h-full flex-col rounded-2xl border border-aura/15 bg-card p-6" data-id="element-257" data-mp="10px1i79gsm34" data-mpi={i}>
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-aura/10 text-aura" data-id="element-258" data-mp="3cgenatiezu3f">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-259" data-mp="3gg5dow41487f" />
                </span>
                <h3 className="mt-4 text-base font-bold leading-snug text-plum sm:text-lg" data-id="element-260" data-mp="2jrphwiabt2lv">
                  {card.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-plum/75" data-id="element-261" data-mp="2sr49xm655l8h">
                  {card.description}
                </p>
              </motion.article>;
        })}
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center font-serif-display text-lg font-bold leading-snug text-plum sm:text-xl" data-id="element-262" data-mp="2xjnnwk8qqidt">
          No necesitás hacerlo perfecto. Solo necesitás{' '}
          <span className="text-aura" data-id="element-263" data-mp="24zfa7kqzpuhi">elegir un lugar por donde comenzar</span>.
        </p>

        <ul className="mx-auto mt-8 grid max-w-3xl gap-3 sm:grid-cols-2" data-id="element-264" data-mp="1lusn3n8eo9mz">
          {trustItems.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-265" data-mp="1gvpghycs1vcw">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold/15 text-gold" data-id="element-266" data-mp="1vnrlfwtpfejs">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-267" data-mp="1quoqpld6xz20" />
              </span>
              <span className="text-sm leading-relaxed text-plum/80" data-id="element-268" data-mp="24ltki6tvnx4f">{item}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}